// App.js
import React from 'react';
import Dashboard from './components/MainAppGUI/Dashboard';

function App() {
  return <Dashboard />;
}

export default App;